import { render } from "./RecentBikes.vue?vue&type=template&id=430fd4b9&ts=true"
import script from "./RecentBikes.vue?vue&type=script&lang=ts"
export * from "./RecentBikes.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__